<template>
  <div v-if="pendingNotices.length"
       class="flex flex-wrap items-center gap-x-3 gap-y-1 mb-2 px-3 py-2 rounded-lg border border-blue-200 dark:border-blue-900 bg-blue-50 dark:bg-blue-950/40 text-xs text-blue-900 dark:text-blue-200">
    <BellAlertIcon class="h-4 w-4 flex-shrink-0" />
    <span class="flex-1 min-w-0">
      {{ who }} will be notified of the schedule change {{ when }}.
    </span>
    <button class="px-2.5 py-1 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60 transition-colors"
            :disabled="sending" @click="sendNow">{{ sending ? 'Sending…' : 'Send now' }}</button>
  </div>
</template>

<script setup>
// "Amenda Etienne will be notified in 12 min · Send now" — notices wait out a quiet
// period so a teacher rearranging their week sends each family one email.
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { BellAlertIcon } from '@heroicons/vue/24/outline'
import { lessonsChange } from '@/composables/useCalendarData.js'
import { pendingNotices, refreshScheduleNotices, sendScheduleNoticesNow } from '@/composables/useScheduleNotices.js'

const now = ref(Date.now())
let timer
onMounted(() => {
  refreshScheduleNotices()
  timer = setInterval(() => {
    now.value = Date.now()
    // Refetch once something is due, so sent notices drop off the bar.
    if (pendingNotices.value.some(n => Date.parse(n.due_at) <= now.value)) refreshScheduleNotices()
  }, 15000)
})
onUnmounted(() => clearInterval(timer))
watch(lessonsChange, () => refreshScheduleNotices())

const who = computed(() => {
  const n = pendingNotices.value
  return n.length === 1 ? n[0].contact_name : `${n.length} families`
})

const when = computed(() => {
  const next = Math.min(...pendingNotices.value.map(n => Date.parse(n.due_at)))
  const mins = Math.ceil((next - now.value) / 60000)
  return mins <= 1 ? 'in about a minute' : `in ${mins} min`
})

const sending = ref(false)
async function sendNow() {
  sending.value = true
  try { await sendScheduleNoticesNow() } finally { sending.value = false }
}
</script>
